/* tslint:disable */
/* eslint-disable */
/**
 * FOPkasa.Web
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import globalAxios, { AxiosResponse, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { CashRegisterOverviewResponse } from '../models';
import { GetCashRegisterOverviewResponse } from '../models';
/**
 * CashRegisterOverviewApi - axios parameter creator
 * @export
 */
export const CashRegisterOverviewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} cashRegisterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCashRegisterOverviewCashRegisterIdGet: async (cashRegisterId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cashRegisterId' is not null or undefined
            if (cashRegisterId === null || cashRegisterId === undefined) {
                throw new RequiredError('cashRegisterId','Required parameter cashRegisterId was null or undefined when calling apiCashRegisterOverviewCashRegisterIdGet.');
            }
            const localVarPath = `/api/CashRegisterOverview/{cashRegisterId}`
                .replace(`{${"cashRegisterId"}}`, encodeURIComponent(String(cashRegisterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiCashRegisterOverviewGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/CashRegisterOverview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions :AxiosRequestConfig = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            if (configuration && configuration.apiKey) {
                const localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? await configuration.apiKey("Authorization")
                    : await configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.params) {
                query.set(key, options.params[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CashRegisterOverviewApi - functional programming interface
 * @export
 */
export const CashRegisterOverviewApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} cashRegisterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCashRegisterOverviewCashRegisterIdGet(cashRegisterId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<CashRegisterOverviewResponse>>> {
            const localVarAxiosArgs = await CashRegisterOverviewApiAxiosParamCreator(configuration).apiCashRegisterOverviewCashRegisterIdGet(cashRegisterId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCashRegisterOverviewGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<AxiosResponse<GetCashRegisterOverviewResponse>>> {
            const localVarAxiosArgs = await CashRegisterOverviewApiAxiosParamCreator(configuration).apiCashRegisterOverviewGet(options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs :AxiosRequestConfig = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * CashRegisterOverviewApi - factory interface
 * @export
 */
export const CashRegisterOverviewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @param {number} cashRegisterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCashRegisterOverviewCashRegisterIdGet(cashRegisterId: number, options?: AxiosRequestConfig): Promise<AxiosResponse<CashRegisterOverviewResponse>> {
            return CashRegisterOverviewApiFp(configuration).apiCashRegisterOverviewCashRegisterIdGet(cashRegisterId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiCashRegisterOverviewGet(options?: AxiosRequestConfig): Promise<AxiosResponse<GetCashRegisterOverviewResponse>> {
            return CashRegisterOverviewApiFp(configuration).apiCashRegisterOverviewGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CashRegisterOverviewApi - object-oriented interface
 * @export
 * @class CashRegisterOverviewApi
 * @extends {BaseAPI}
 */
export class CashRegisterOverviewApi extends BaseAPI {
    /**
     * 
     * @param {number} cashRegisterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashRegisterOverviewApi
     */
    public async apiCashRegisterOverviewCashRegisterIdGet(cashRegisterId: number, options?: AxiosRequestConfig) : Promise<AxiosResponse<CashRegisterOverviewResponse>> {
        return CashRegisterOverviewApiFp(this.configuration).apiCashRegisterOverviewCashRegisterIdGet(cashRegisterId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashRegisterOverviewApi
     */
    public async apiCashRegisterOverviewGet(options?: AxiosRequestConfig) : Promise<AxiosResponse<GetCashRegisterOverviewResponse>> {
        return CashRegisterOverviewApiFp(this.configuration).apiCashRegisterOverviewGet(options).then((request) => request(this.axios, this.basePath));
    }
}
